import { Roles } from "@src/domains/shared/models/Enums/Roles";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const CustomerProcessList = lazy(
  () => import("@src/domains/Process/pages/CustomerProcessList"),
);
const ServiceList = lazy(
  () => import("@src/domains/Service/pages/ServiceList"),
);
const OfficeProcessList = lazy(
  () => import("@src/domains/Process/pages/OfficeProcessList"),
);
const ProcessDetails = lazy(
  () => import("@src/domains/Process/pages/ProcessDetails"),
);
const InventoryList = lazy(
  () => import("@src/domains/Inventory/pages/InventoryList"),
);
const InventoryDetails = lazy(
  () => import("@src/domains/Inventory/pages/InventoryDetails"),
);
const UsersList = lazy(() => import("@src/domains/administration/pages/UsersManagement"));
const CustomerManagement = lazy(
  () => import("@src/domains/administration/pages/CustomerManagement"),
);
const ManufacturerManagement = lazy(
  () => import("@src/domains/administration/pages/ManufacturerManagement"),
);
const ServiceCatalogManagement = lazy(
  () => import("@src/domains/administration/pages/ServiceCatalogManagement"),
);
const AccessControl = lazy(
  () => import("@src/domains/shared/components/AccessControl/AccessControl"),
);
const MainContainer = lazy(
  () => import("@src/domains/shared/components/MainContainer"),
);

export interface ILayout {
  isAuth: boolean;
}

const DesktopRoutes = () => {
  return (
    <MainContainer>
      <Routes>
        <Route path="admin">
          <Route path="users" element={<UsersList />} />
          <Route path="office-list" element={<OfficeProcessList />} />
          <Route path="customer-list" element={<CustomerProcessList />} />
          <Route path="services" element={<ServiceList />} />
          <Route path="inventory" element={<InventoryList />} />
          <Route
            path="inventory/:inventoryId/details"
            element={
              <div className="overflow-y-auto w-full">
                <InventoryDetails />
              </div>
            }
          />
          <Route
            path="customers"
            element={
              <AccessControl
                allowedRoles={[
                  Roles.SuperAdmin,
                  Roles.ProcessAdmin,
                  Roles.ServiceAdmin,
                  Roles.InventoryAdmin,
                ]}>
                <CustomerManagement />
              </AccessControl>
            }
          />
          <Route path="manufacturers" element={
            <AccessControl allowedRoles={[Roles.SuperAdmin, Roles.ServiceAdmin, Roles.ProcessAdmin]}>
              <ManufacturerManagement />
            </AccessControl>
          } />
          <Route
            path="service-catalog"
            element={
              <AccessControl allowedRoles={[Roles.SuperAdmin, Roles.ServiceAdmin]}>
                <ServiceCatalogManagement />
              </AccessControl>
            }
          />
        </Route>
        <Route
          path="customer"
          element={
            <AccessControl allowedRoles={[Roles.ProcessCustomer]}>
              <CustomerProcessList />
            </AccessControl>
          }
        />
        <Route
          path="office"
          element={
            <AccessControl allowedRoles={[Roles.ProcessOffice]}>
              <OfficeProcessList />
            </AccessControl>
          }
        />
        <Route
          path="services"
          element={
            <AccessControl
              allowedRoles={[
                Roles.Service,
                Roles.ServiceCustomer,
                Roles.ServiceOverview,
              ]}>
              <ServiceList />
            </AccessControl>
          }
        />
        <Route
          path="process/:processId/details"
          element={
            <div className=" overflow-y-auto w-full">
              <ProcessDetails />
            </div>
          }
        />
        <Route
          path="inventory"
          element={
            <AccessControl allowedRoles={[Roles.InventoryManager]}>
              <InventoryList />
            </AccessControl>
          }
        />
        <Route
          path="inventory/:inventoryId/details"
          element={
            <div className="overflow-y-auto w-full">
              <InventoryDetails />
            </div>
          }
        />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </MainContainer>
  );
};

export default DesktopRoutes;
